const rulesFormatter = (val, valueOnly) => {
  if (val === null) {
    return 'Please Select';
  }

  if (
    !Array.isArray(val) ||
    val.length === 0 ||
    (val.length === 1 && val[0].value === '')
  ) {
    return 'All';
  }

  if (valueOnly) {
    return `${val.length} items`;
  }

  let displayItems = val;
  const DISPLAY_COUNT = 3;
  if (val.length > DISPLAY_COUNT) {
    displayItems = val.slice(0, DISPLAY_COUNT);
    displayItems.push({
      label: `...More(${val.length - DISPLAY_COUNT})`,
      value: '',
      textColor: '#000000',
    });
  }

  return (
    <ul style={{ margin: 0, padding: 0, textAlign: 'left' }}>
      {displayItems.map(item => (
        <li key={item.value} style={{ color: item.textColor || 'inherit' }}>
          {item.label}
        </li>
      ))}
    </ul>
  );
};

export default rulesFormatter;
